import React from 'react';
import { Check, Flex, NumberWrapper, PricingContainer } from './PricingCTA.styles';
import { SpacingStack } from '@components/SpacingStack';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { Text } from '@components/typography';

import { pricingCTAData } from '@data-ts/components/PricingCTA';

export const PricingCTA: React.FC = () => {
  const sellingPoints = pricingCTAData.sellingPoints;
  return (
    <Box paddingY={[8, 8, 11]}>
      <Columns>
        <Columns.Column width="half">
          <PricingContainer>
            <NumberWrapper>
              <Text tagName="p" color="purple6" variant="hed72Hero" style={{ alignSelf: 'flex-start' }}>
                $
              </Text>
              <Text tagName="h2" color="purple6" variant="hed72Hero" style={{ fontSize: '256px' }}>
                0
              </Text>
              <Text tagName="p" color="purple6" variant="hed72Hero" style={{ alignSelf: 'flex-end' }}>
                /mo
              </Text>
            </NumberWrapper>
          </PricingContainer>
        </Columns.Column>
        <Columns.Column width="half">
          <Flex justifyContent="center" marginBottom="64px" mobileJustifyContent="flex-start">
            <SpacingStack spacing={8}>
              {sellingPoints.map((item, index) => (
                <Flex key={index} justifyContent="flex-start">
                  <Check />
                  <Text tagName="h3" color="purple6" variant="dek24" style={{ fontWeight: 'bold', margin: 0 }}>
                    {item}
                  </Text>
                </Flex>
              ))}
            </SpacingStack>
          </Flex>
        </Columns.Column>
      </Columns>
    </Box>
  );
};
